import React, { useCallback } from "react";
import "./PracticeByCoursesHandPlayTab.scss";

// image imports
import CardCourseIcon from "assets/images/CardCourse-icon.svg";
import InteractiveIcon from "assets/images/interactiveBidding.png";
import LockIcon from "assets/images/DeffenceScreenLock-icon.svg";
import ElipseDisabled from "assets/icons/elipseDisabled.svg";
import DeffeseIcon from "assets/images/deffenseIcon.svg";

interface Props {
  data?: any[];
  onPressItem?: (val: any, type: "interactive-bidding" | "bidding") => void;
  searchData?: any[];
  isDeffense?: boolean;
}

function PracticeByCoursesHandPlayTab({ data, isDeffense, searchData, onPressItem }: Props) {
  const renderItem = useCallback(
    (item: any, index_item: any) => {
      return (
        <div
          style={{
            flexDirection: "row",
            flexWrap: "wrap",
            flex: 1,
            display: "flex"
          }}
          key={index_item}>
          {item?.map((val: any, index: number) => {
            if (val === null) {
              return (
                <div className="list-item-courses" key={`${index}`} style={{ opacity: 0 }}></div>
              );
            }

            if (!val?.Data?.IsDisplayed) {
              return null;
            }
            const isDisabled = typeof val?.isEnabled === "boolean" && !val?.isEnabled;
            return (
              <div
                className="list-item-courses"
                key={`${val.Data?.Id_Category}_${index}_${val?.Data?.CategoryIndex}`}
                onClick={() => {
                  if (isDisabled) {
                    return;
                  }
                  onPressItem &&
                    onPressItem(
                      val,
                      val?.type === "interactive" ? "interactive-bidding" : "bidding"
                    );
                }}>
                <div className="PracticeByCoursesTab-handplay-a">
                  <div className="icon-otr-list-icons-courses-wrapper">
                    {isDisabled ? (
                      <div style={{ position: "relative" }}>
                        <div
                          style={{
                            position: "relative",
                            justifyContent: "center",
                            alignItems: "center",
                            display: "flex",
                            background: "none"
                          }}
                          className={"icon-otr list-icons-courses list-icons-courses-disabled"}>
                          <img src={ElipseDisabled} />
                          <img
                            loading="lazy"
                            className={`deffence-icon deffence-icon1 ${
                              val?.type === "interactive" ? "interactive-icon" : ""
                            }`}
                            style={{ position: "absolute", width: 52, height: 62 }}
                            src={isDisabled ? LockIcon : CardCourseIcon}
                            alt="icon"
                          />
                        </div>
                      </div>
                    ) : (
                      <>
                        <div className={"icon-otr list-icons-courses"}>
                          <img
                            className={`deffence-icon deffence-icon1 ${
                              val?.type === "interactive" ? "interactive-icon" : ""
                            }`}
                            src={isDeffense ? DeffeseIcon : CardCourseIcon}
                            loading="lazy"
                            alt={`${val.Data?.Id_Category}_${index}_${val?.Data?.CategoryIndex}`}
                          />
                        </div>
                      </>
                    )}
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      flex: 1,
                      width: "100%"
                    }}>
                    <span
                      className="handplay-icon-text"
                      style={{
                        color: isDisabled ? "rgba(120, 101, 158, 1)" : undefined
                      }}>
                      {val.Data?.CourseTitle}
                    </span>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      );
    },
    [isDeffense, onPressItem]
  );

  if (searchData && searchData?.length > 0) {
    return (
      <div className="PracticeByCoursesTab-main">
        <div className="PracticeByCoursesTab-ul">
          <div
            style={{
              flexDirection: "row",
              flexWrap: "wrap",
              flex: 1,
              display: "flex"
            }}>
            {searchData.map((val: any, index: number) => {
              if (val === null) {
                return null;
              }
              const isDisabled = typeof val?.isEnabled === "boolean" && !val?.isEnabled;
              return (
                <div
                  className="list-item-courses"
                  key={`${val.Data?.Id_Course}_${index}_${val?.Data?.CourseKey}`}
                  onClick={() =>
                    !isDisabled &&
                    onPressItem &&
                    onPressItem(
                      val,
                      val?.type === "interactive" ? "interactive-bidding" : "bidding"
                    )
                  }>
                  <div className="PracticeByCoursesTab-handplay-a">
                    {isDisabled ? (
                      <div style={{ position: "relative" }}>
                        <div
                          style={{
                            position: "relative",
                            justifyContent: "center",
                            alignItems: "center",
                            display: "flex",
                            background: "none"
                          }}
                          className={"icon-otr list-icons-courses list-icons-courses-disabled"}>
                          <img src={ElipseDisabled} />
                          <img
                            className={`deffence-icon deffence-icon1 ${
                              val?.type === "interactive" ? "interactive-icon" : ""
                            }`}
                            style={{ position: "absolute", width: 52, height: 62 }}
                            src={isDisabled ? LockIcon : CardCourseIcon}
                            alt="icon"
                          />
                        </div>
                      </div>
                    ) : (
                      <>
                        <div className="gradient-icon-otr"></div>

                        <div className="icon-otr list-icons-courses">
                          <img
                            className={`deffence-icon deffence-icon1 ${
                              val?.type === "interactive" ? "interactive-icon" : ""
                            }`}
                            src={
                              isDeffense
                                ? DeffeseIcon
                                : val?.type === "interactive"
                                ? InteractiveIcon
                                : CardCourseIcon
                            }
                            alt="icon"
                          />
                          <img className="deffence-icon deffence-icon2" src={LockIcon} alt="icon" />
                        </div>
                      </>
                    )}

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        flex: 1,
                        width: "100%"
                      }}>
                      <span
                        className="handplay-icon-text"
                        style={{ color: isDisabled ? "rgba(120, 101, 158, 1)" : undefined }}>
                        {val.Data?.CourseTitle}
                      </span>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  }
  return (
    <>
      <div className="PracticeByCoursesTab-main">
        <div className="PracticeByCoursesTab-ul">
          {data?.map((item, index_item) => {
            return renderItem(item, index_item);
          })}
        </div>
      </div>
    </>
  );
}

export default PracticeByCoursesHandPlayTab;
